import { useBreakpoints } from '../../support/hooks/useBreakpoints';
import { SearchableSelectFieldMobile } from './SearchableSelectFieldMobile';
import { SearchableSelectFieldDesktop } from './SearchableSelectFieldDesktop';

export interface ISearchSelectOption<T = string> {
    label: string;
    value: T;
}

export interface ISelected<T = string> {
    label: string;
    value?: T;
}

export interface ISearchableSelectFieldProps<T> {
    readonly?: boolean;
    selected?: ISelected<T>;
    options?: ISearchSelectOption<T>[];
    loadOptions?: (text: string, callback: (options: ISearchSelectOption<T>[]) => void) => void;
    onChange: (selected?: ISelected<T>) => void;
    label: string;
    placeholder?: string;
    required?: boolean;
    allowCustom?: boolean;
    noInputMessage?: string;
    'data-type'?: string;
}

export const SearchableSelectField = <T,>({
    'data-type': dataType,
    label,
    placeholder,
    required = false,
    allowCustom = false,
    noInputMessage,
    readonly = false,
    selected,
    onChange,
    options,
    loadOptions
}: ISearchableSelectFieldProps<T>) => {
    const { isBelowBreakpoint } = useBreakpoints();
    if (isBelowBreakpoint('sm')) {
        return (
            <SearchableSelectFieldMobile
                readonly={readonly}
                data-type={dataType}
                label={label}
                placeholder={placeholder}
                required={required}
                allowCustom={allowCustom}
                noInputMessage={noInputMessage}
                selected={selected}
                onChange={onChange}
                options={options}
                loadOptions={loadOptions}
            />
        );
    } else {
        return (
            <SearchableSelectFieldDesktop
                readonly={readonly}
                data-type={dataType}
                label={label}
                placeholder={placeholder}
                required={required}
                allowCustom={allowCustom}
                noInputMessage={noInputMessage}
                selected={selected}
                onChange={onChange}
                options={options}
                loadOptions={loadOptions}
            />
        );
    }
};
